import Authenticate from "./before/authenticate.js"
import RedirectIfAuthenticated from "./before/redirect-if-authenticated.js"
import SocketInit from "./after/socket-init.js"
import BeforeApiExec from "./before/before-api-exec.js"
import IsAdmin from "./before/is-admin.js"
import AfterApiExec from "./after/after-api-exec.js"
import MoveParticipant from "./after/move-participant.js"
import TalkRoomExists from "./before/talk-room-exists"
import SideMenuManager from "./after/side-menu-manager.js"
import HallByRouteSlugExists from "./before/hall-by-route-slug-exists.js"
import RoomByRouteSlugExists from "./before/room-by-route-slug-exists.js"

const before = [Authenticate, RedirectIfAuthenticated, BeforeApiExec, IsAdmin, TalkRoomExists, HallByRouteSlugExists, RoomByRouteSlugExists]

const after = [AfterApiExec, MoveParticipant, SocketInit, SideMenuManager]

export default (route, Vue, store) => {
  before.forEach(Class => {
    route.beforeEach((to, from, next) => {
      if (!store.getters["loading/loading"]) store.dispatch("loading/setLoading", true)

      const middleware = new Class(Vue, store)
      middleware.exec(to, from, next)
    })
  })

  after.forEach(Class => {
    route.afterEach((to, from) => {
      let title = to.path.includes("errors") || to.name === "SystemTop" ? to.meta.title : `${store.getters["event/event"].name} | ${to.meta.title}`

      if (document.title !== title) {
        document.title = title
      }

      const middleware = new Class(Vue, store)
      middleware.exec(to, from)
    })
  })
}
